var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5879_54506)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2447 25.8285C29.3982 31.5479 24.5541 36.0378 18.6301 38.4289C9.87639 41.9619 2.52779 50.0361 0.195762 62.6593C-0.0601759 64.0445 -0.0639259 65.4683 0.192246 66.8535C3.81264 86.4409 19.5043 95.0804 33.7861 92.7896C41.7842 91.5064 49.8811 94.1743 55.8094 99.6946C67.8643 110.919 87.1885 114.439 105.948 102.407C108.145 100.997 111.094 98.0389 112.502 95.8405C128.666 70.6051 116.692 44.3448 95.6801 36.1553C90.1264 33.9903 85.4344 30.0404 82.5645 24.8157C77.739 16.0299 68.4012 10.074 57.669 10.074C46.5294 10.074 36.8926 16.4905 32.2447 25.8285Z",
    fill: "url(#paint0_linear_5879_54506)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5879_54506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 121
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00038147H120V120H0V0.00038147Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5879_54506)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5879_54506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 19,
    width: 94,
    height: 68
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.124 19.8142H106.874V86.4353H13.124V19.8142Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5879_54506)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.875 23.3293V82.9192C106.875 84.8598 105.3 86.4348 103.359 86.4348H16.6406C14.7 86.4348 13.125 84.8598 13.125 82.9192V23.3293C13.125 21.389 14.7 19.8137 16.6406 19.8137H103.359C105.3 19.8137 106.875 21.389 106.875 23.3293Z",
    fill: "#005B99"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.292 108.397H46.709L52.0251 87.3262H67.9759L73.292 108.397Z",
    fill: "#337CAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8266 94.6625H50.1729L52.0242 87.3261H67.9753L69.8266 94.6625Z",
    fill: "#8AB4D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.875 28.2524V87.8423C106.875 89.7827 105.3 91.3579 103.359 91.3579H16.6406C14.7 91.3579 13.125 89.7827 13.125 87.8423V28.2524C13.125 26.3118 14.7 24.7368 16.6406 24.7368H103.359C105.3 24.7368 106.875 26.3118 106.875 28.2524Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3266 79.5469H30.6719V36.0265H89.3266V79.5469Z",
    fill: "#E6EFF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.875 36.0267V28.2523C106.875 26.3105 105.301 24.7367 103.359 24.7367H16.6406C14.6991 24.7367 13.125 26.3105 13.125 28.2523V36.0267H106.875Z",
    fill: "#337CAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.292 108.397H46.709L52.0251 87.3262H67.9759L73.292 108.397Z",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 79.547V87.8416C13.125 89.7831 14.6991 91.3572 16.6406 91.3572H103.359C105.301 91.3572 106.875 89.7831 106.875 87.8416V79.547H13.125Z",
    fill: "#8AB4D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2031 108.396H77.797",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0498 30.363V30.3987",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5801 30.3629V30.3986",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1084 30.363V30.3987",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.875 73.092V28.2519C106.875 26.3103 105.301 24.7363 103.359 24.7363H16.6406C14.6991 24.7363 13.125 26.3103 13.125 28.2519V36.0266H106.875",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 42.4816V87.8416C13.125 89.7831 14.6991 91.3572 16.6406 91.3572H103.359C105.301 91.3572 106.875 89.7831 106.875 87.8416V79.547H13.125",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7938 68.4314H44.043C42.7485 68.4314 41.6992 67.3821 41.6992 66.0877V44.3438C41.6992 43.0493 42.7485 42 44.043 42H76.7938C78.0883 42 79.1376 43.0493 79.1376 44.3438V66.0879C79.1376 67.3821 78.0883 68.4314 76.7938 68.4314Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1073 55.1524H47.873C47.2259 55.1524 46.7012 54.6277 46.7012 53.9805V47.1387C46.7012 46.4916 47.2259 45.9668 47.873 45.9668H73.1073C73.7544 45.9668 74.2791 46.4916 74.2791 47.1387V53.9805C74.2791 54.6277 73.7544 55.1524 73.1073 55.1524Z",
    fill: "#B0CCDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6394 60.2998H60.2109C59.5638 60.2998 59.0391 59.775 59.0391 59.1279C59.0391 58.4808 59.5638 57.9561 60.2109 57.9561H72.6394C73.2865 57.9561 73.8112 58.4808 73.8112 59.1279C73.8112 59.775 73.2865 60.2998 72.6394 60.2998Z",
    fill: "#FFF2AB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6394 64.4573H60.2109C59.5638 64.4573 59.0391 63.9325 59.0391 63.2854C59.0391 62.6383 59.5638 62.1135 60.2109 62.1135H72.6394C73.2865 62.1135 73.8112 62.6383 73.8112 63.2854C73.8112 63.9327 73.2865 64.4573 72.6394 64.4573Z",
    fill: "#FFF2AB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8115 50.3242C71.4587 50.3242 71.9834 49.7996 71.9834 49.1523C71.9834 48.5051 71.4587 47.9805 70.8115 47.9805C70.1643 47.9805 69.6396 48.5051 69.6396 49.1523C69.6396 49.7996 70.1643 50.3242 70.8115 50.3242Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6631 50.3242C67.3103 50.3242 67.835 49.7996 67.835 49.1523C67.835 48.5051 67.3103 47.9805 66.6631 47.9805C66.0159 47.9805 65.4912 48.5051 65.4912 49.1523C65.4912 49.7996 66.0159 50.3242 66.6631 50.3242Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5137 50.3242C63.1609 50.3242 63.6855 49.7996 63.6855 49.1523C63.6855 48.5051 63.1609 47.9805 62.5137 47.9805C61.8665 47.9805 61.3418 48.5051 61.3418 49.1523C61.3418 49.7996 61.8665 50.3242 62.5137 50.3242Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2424 57.8418C56.2424 55.6947 54.4956 53.9481 52.3488 53.9481C50.2019 53.9481 48.4551 55.6949 48.4551 57.8418C48.4551 58.9007 48.8812 59.8609 49.5695 60.5636C48.8814 61.2662 48.4551 62.2265 48.4551 63.2854C48.4551 63.9325 48.9796 64.4573 49.627 64.4573C50.2743 64.4573 50.7988 63.9325 50.7988 63.2854C50.7988 62.4309 51.4942 61.7355 52.3488 61.7355C53.2033 61.7355 53.8987 62.4309 53.8987 63.2854C53.8987 63.9325 54.4232 64.4573 55.0705 64.4573C55.7179 64.4573 56.2424 63.9325 56.2424 63.2854C56.2424 62.2265 55.8163 61.2662 55.128 60.5636C55.8163 59.8609 56.2424 58.9007 56.2424 57.8418ZM52.3488 56.2919C53.2033 56.2919 53.8987 56.9873 53.8987 57.8418C53.8987 58.6963 53.2033 59.3917 52.3488 59.3917C51.4942 59.3917 50.7988 58.6963 50.7988 57.8418C50.7988 56.987 51.494 56.2919 52.3488 56.2919Z",
    fill: "#B0CCDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.332 49.8655C83.6849 49.8655 83.1602 49.3407 83.1602 48.6936C83.1602 47.9827 82.582 47.4045 81.8711 47.4045C81.224 47.4045 80.6992 46.8798 80.6992 46.2327C80.6992 45.5856 81.224 45.0608 81.8711 45.0608C82.582 45.0608 83.1602 44.4826 83.1602 43.7717C83.1602 43.1246 83.6849 42.5999 84.332 42.5999C84.9791 42.5999 85.5039 43.1246 85.5039 43.7717C85.5039 44.4826 86.0821 45.0608 86.793 45.0608C87.4401 45.0608 87.9648 45.5856 87.9648 46.2327C87.9648 46.8798 87.4401 47.4045 86.793 47.4045C86.0821 47.4045 85.5039 47.9827 85.5039 48.6936C85.5039 49.3407 84.9791 49.8655 84.332 49.8655Z",
    fill: "#337CAD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2707 45.4872C35.9707 45.4872 35.6709 45.3728 35.4419 45.1441C34.9842 44.6863 34.9842 43.9443 35.4419 43.4868L37.7857 41.1431C38.2434 40.6856 38.9852 40.6856 39.4429 41.1431C39.9007 41.6008 39.9007 42.3428 39.4429 42.8003L37.0992 45.1441C36.8704 45.3728 36.5707 45.4872 36.2707 45.4872Z",
    fill: "#FFE86E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5312 70.8655C33.8841 70.8655 33.3594 70.3407 33.3594 69.6936C33.3594 68.9827 32.7812 68.4045 32.0703 68.4045C31.4232 68.4045 30.8984 67.8798 30.8984 67.2327C30.8984 66.5856 31.4232 66.0608 32.0703 66.0608C32.7812 66.0608 33.3594 65.4826 33.3594 64.7717C33.3594 64.1246 33.8841 63.5999 34.5312 63.5999C35.1784 63.5999 35.7031 64.1246 35.7031 64.7717C35.7031 65.4826 36.2813 66.0608 36.9922 66.0608C37.6393 66.0608 38.1641 66.5856 38.1641 67.2327C38.1641 67.8798 37.6393 68.4045 36.9922 68.4045C36.2813 68.4045 35.7031 68.9827 35.7031 69.6936C35.7031 70.3407 35.1784 70.8655 34.5312 70.8655Z",
    fill: "#FFE86E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 67.9991H49.3568C50.0206 67.9991 50.5587 67.4608 50.5587 66.797C50.5587 66.1333 50.0206 65.5949 49.3568 65.5949H43.5898C42.9258 65.5949 42.3877 66.1333 42.3877 66.797C42.3877 67.4608 42.9258 67.9991 43.5898 67.9991Z",
    fill: "#FFFBE4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9902 69.767H75.81C76.4739 69.767 77.0121 69.2288 77.0121 68.5651C77.0121 67.9011 76.4739 67.363 75.81 67.363H42.9902C42.3262 67.363 41.7881 67.9011 41.7881 68.5651C41.7881 69.2288 42.3262 69.767 42.9902 69.767Z",
    fill: "#FFCD00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7065 43.3671H67.7806C68.2879 43.3671 68.699 42.8289 68.699 42.1652C68.699 41.5012 68.2879 40.9631 67.7806 40.9631H42.7065C42.1992 40.9631 41.7881 41.5012 41.7881 42.1652C41.7881 42.8289 42.1992 43.3671 42.7065 43.3671Z",
    fill: "#FFCD00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4227 16.7566L77.8457 14.1799L80.4227 11.6029L82.9996 14.1799L80.4227 16.7566Z",
    stroke: "#337CAD",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1082 106.76L28.5312 104.184L31.1082 101.607L33.6852 104.184L31.1082 106.76Z",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1258 101.845L82.5488 99.2679L85.1258 96.6912L87.7027 99.2679L85.1258 101.845Z",
    stroke: "#8AB4D0",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8025 108.167L94.2256 105.59L96.8025 103.013L99.3795 105.59L96.8025 108.167Z",
    stroke: "#005B99",
    strokeWidth: 2.34375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5879_54506",
    x1: 117.502,
    y1: 103.532,
    x2: 5.63717,
    y2: 128.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EFF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5879_54506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a9c9107400e4278666c6627a72345495.svg";
export { ForwardRef as ReactComponent };